module.exports = __webpack_public_path__ + "static/media/logo.63894b13.svg";